import { useState } from "react";
import { KeyboardArrowDown, KeyboardArrowUp } from "@mui/icons-material";
import {
  Table,
  TableRow,
  TableBody,
  TableCell,
  IconButton,
  Collapse,
  Box,
  Typography,
  tableCellClasses,
  Badge,
  useTheme
} from "@mui/material";
import { styled } from "@mui/material/styles";
import IconConstants from "../../utils/IconConstants";
import { Helper } from "../../utils/Helpers";
import { useTranslation } from "react-i18next";

const { getLocalTimeFromUtc } = new Helper();
const StyledTableCell = styled(TableCell)(
  ({ theme, color, borderBottom, backgroundColor }) => ({
    [`&.${tableCellClasses.head}`]: {
      background: theme.palette.tab.gradient,
      color: theme.palette.primary.contrastText,
      fontWeight: 700,
    },
    [`&.${tableCellClasses.body}`]: {
      fontSize: 14,
      fontWeight: 500,
      color: !!color ? color : "#707070",
      backgroundColor: backgroundColor,
      borderBottom: borderBottom,
      [theme.breakpoints.up("md")]: {
        fontSize: "0.83vw",
      },
      [theme.breakpoints.down("md")]: {
        fontSize: "1.44vw",
      },
      [theme.breakpoints.down("sm")]: {
        fontSize: "3.08vw",
      },
    },
  })
);

const CollapsedTableCell = styled(TableCell)(({ theme, bodyWidth }) => ({
  [`&.${tableCellClasses.head}`]: {
    fontSize: 16,
    fontWeight: 600,
    paddingBottom: 0,
    border: 0,
  },
  [`&.${tableCellClasses.body}`]: {
    fontWeight: 500,
    width: bodyWidth,
    border: 0,
    color: "#252525",
    [theme.breakpoints.up("md")]: {
      fontSize: "0.83vw",
    },
    [theme.breakpoints.down("md")]: {
      fontSize: "1.44vw",
    },
    [theme.breakpoints.down("sm")]: {
      fontSize: "3.08vw",
    },
  },
}));

const Row = (props) => {
  const { t } = useTranslation();
  const { palette } = useTheme();
  const { row, index } = props;
  const [open, setOpen] = useState(false);

  return (
    <>
      <TableRow
        sx={{
          borderBottom: !open && "1px solid #FFE9B6",
          backgroundColor: open && "#FFFBF0",
        }}
      >
        <StyledTableCell
          sx={{
            borderBottom: !open ? "1px solid #FFE9B6" : "none",
            backgroundColor: open && "#FFFBF0",
          }}
        >
          <Badge
            showZero
            badgeContent={row?.booked_rooms?.length}
            overlap="circular"
            sx={{
              "& .MuiBadge-badge": {
                fontSize: 8,
                height: 14,
                width: 14,
                minWidth: 0,
                fontWeight: 500,
                color: palette.primary.contrastText,
                border : `0.5px solid ${palette.primary.contrastText}`,
                background: palette.tab.gradient,
              },
            }}
          >
            <Box
              sx={{
                background: palette.tab.gradient,
                borderRadius: "50%",
                width: { xs: "8.33vw", sm: "4.317vw", md: "2.431vw" },
                height: { xs: "8.33vw", sm: "4.317vw", md: "2.431vw" },
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <Typography
                sx={{
                  fontSize: {
                    xs: "2.56vw",
                    sm: "1.319vw",
                    md: "0.764vw",
                  },
                  fontWeight: 500,
                  color: palette.text.contrast,
                }}
              >
                {row?.booked_rooms?.[0]?.room_no || ""}
              </Typography>
            </Box>
          </Badge>
        </StyledTableCell>
        {/* <StyledTableCell
          borderBottom={!open ? "1px solid #FFE9B6" : "none"}
          color={open ? "#DEA829" : "#707070"}
          sx={{ paddingRight: 0, paddingLeft: 0 }}
        >
          {index.toString().padStart(2, "0")}
        </StyledTableCell> */}
        <StyledTableCell
          borderBottom={"1px solid #FFE9B6"}
          color={open ? "#DEA829" : "#707070"}
        >
          {row?.name?.length > 15 ? `${row?.name.slice(0, 15)}...` : row?.name}
        </StyledTableCell>
        <StyledTableCell
          borderBottom={"1px solid #FFE9B6"}
          color={open ? "#DEA829" : "#707070"}
        >
          {row?.mobile}
        </StyledTableCell>

        <StyledTableCell
          backgroundColor={open && "#FFFBF0"}
          align="center"
          borderBottom={!open ? "1px solid #FFE9B6" : "none"}
        >
          <IconButton
            aria-label="expand row"
            size="small"
            onClick={() => {
              setOpen(!open);
            }}
          >
            {open ? (
              <KeyboardArrowUp sx={{ color: "#252525" }} fontSize="small" />
            ) : (
              <KeyboardArrowDown sx={{ color: "#B5B5B5" }} fontSize="small" />
            )}
          </IconButton>
        </StyledTableCell>
      </TableRow>
      <TableRow
        sx={{
          borderBottom: open && "1px solid #FFEABA",
          backgroundColor: open && "#FFFBF0",
        }}
      >
        <TableCell
          sx={{
            paddingBottom: 0,
            paddingTop: 0,
            border: "none",
            backgroundColor: open && "#FFFBF0",
          }}
          colSpan={9}
        >
          <Collapse in={open} timeout="auto" unmountOnExit>
            <Table size="small">
              <TableBody>
                {row?.booked_rooms?.map((room, index) => (
                  <TableRow key={index}>
                    <CollapsedTableCell
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        columnGap: "8%",
                        paddingX: 0,
                      }}
                    >
                      <Box
                        sx={{
                          border: `0.5px solid ${palette.border.gradient}`,
                          borderRadius: "50%",
                          width: { xs: "8.33vw", sm: "4.317vw", md: "2.431vw" },
                          height: {
                            xs: "8.33vw",
                            sm: "4.317vw",
                            md: "2.431vw",
                          },
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                        }}
                      >
                        <Typography
                          sx={{
                            fontSize: {
                              xs: "2.56vw",
                              sm: "1.44vw",
                              md: "0.83vw",
                            },
                            color: palette.text.primary,
                            fontWeight: 600,
                          }}
                        >
                          {room?.room_no || ""}
                        </Typography>
                      </Box>
                      {room?.room_type_name || "-"}
                    </CollapsedTableCell>
                    <CollapsedTableCell>
                      <Box
                        sx={{
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                        }}
                      >
                        <span style={{ color: "#878787" }}>
                          {t("pages.home_page.todays_activity.pax")}:
                        </span>{" "}
                        <img
                          src={
                            open
                              ? IconConstants.Adult
                              : IconConstants.AdultBlack
                          }
                          alt=""
                        />
                        {room?.no_of_adults || room?.expected_no_of_adults
                          ? (room.no_of_adults || room.expected_no_of_adults)
                              .toString()
                              .padStart(2, "0")
                          : 0}
                        <img
                          src={
                            open
                              ? IconConstants.Children
                              : IconConstants.ChildrenBlack
                          }
                        />
                        {room?.no_of_children || room?.expected_no_of_children
                          ? (
                              room.no_of_children ||
                              room.expected_no_of_children
                            )
                              .toString()
                              .padStart(2, "0")
                          : 0}
                      </Box>
                    </CollapsedTableCell>
                    <CollapsedTableCell sx={{ textWrap: "wrap", paddingX: 0 }}>
                      {getLocalTimeFromUtc(room?.checkin_date)?.time ||
                        getLocalTimeFromUtc(room?.expected_checkin_date)?.time}
                    </CollapsedTableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </Collapse>
        </TableCell>
      </TableRow>
    </>
  );
};

const ArrivalActivityTable = ({ tableData = [], paymentDetail }) => {
  const { t } = useTranslation();

  return (
    <Table size="small" aria-label="collapsible table">
      <TableBody>
        {tableData?.length > 0 ? (
          tableData.map((row, rowIndex) => (
            <Row
              key={rowIndex}
              index={(rowIndex + 1).toString().padStart(2, "0")}
              row={row}
              paymentDetails={paymentDetail}
            />
          ))
        ) : (
          <TableCell
            align="center"
            sx={{
              paddingY: { md: "18vh" },
              color: "#bab9ba",
              border: "none",
              fontSize: { xs: "3.08vw", sm: 14 },
            }}
          >
            {t("pages.home_page.todays_activity.no_data_found")}
          </TableCell>
        )}
      </TableBody>
    </Table>
  );
};

export default ArrivalActivityTable;
